import React, { forwardRef, useState } from "react";
import RemoteListPicker from "../mobiledpi/RemoteListPicker";
import { api } from "../common/api";
import { Button, Form, NavBar, Space, Stepper } from "antd-mobile";
import { useNavigate, useParams } from "react-router";
import dayjs from "dayjs";
import { requiredField } from "../common/common";
import { SignaturePage } from "../mobiledpi/SignaturePage";

const EmployeePicker = forwardRef((props, ref) => (
  <RemoteListPicker
    title={"Seleziona dipendente"}
    fetchList={(params) => api.employee.list(params)}
    fetchItem={(id) => api.employee.get(id)}
    resource={"employee"}
    labelFn={(emp) => emp.fullName}
    placeholder={"Seleziona Dipendente"}
    ref={ref}
    {...props}
  />
));

export default function () {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const signatureWatch = Form.useWatch("signature", form);
  const navigate = useNavigate();
  const { id } = useParams();
  const onFinish = (values) => {
    const data = {
      employee: values.employee.value,
      equipment: id,
    };
    api.equipmentAssignment
      .create(data)
      .then(() => navigate(`/mobile/success?return=/mobile/equipments/${id}`, { replace: true }))
      .finally(() => setLoading(false));
  };
  return (
    <Space direction={"vertical"} block={true} style={{ "--gap": "32px" }}>
      <NavBar
        onBack={() => navigate("..", { replace: true })}
        style={{ background: "#fff" }}
        right={
          !!signatureWatch && (
            <Button onClick={() => form.setFieldValue("signature", null)}>Sblocca</Button>
          )
        }
      >
        Consegna attrezzatura
      </NavBar>
      <Form
        onFinish={onFinish}
        disabled={!!signatureWatch}
        form={form}
        layout={"horizontal"}
        footer={
          <Button block color={"primary"} type={"submit"} loading={loading}>
            Salva
          </Button>
        }
      >
        <Form.Item
          name={"employee"}
          label="Dipendente"
          rules={[requiredField]}
          onClick={(e, ref) => {
            console.log(ref);
            ref.current?.open();
          }}
        >
          <EmployeePicker />
        </Form.Item>
        <Form.Header>Firma</Form.Header>
        <Form.Item
          name={"signature"}
          rules={[requiredField]}
          label={"Firma del lavoratore"}
          onClick={(e, ref) => ref.current?.open()}
        >
          <SignaturePage />
        </Form.Item>
      </Form>
    </Space>
  );
}
